import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

import {
  useGetBranchAssignmentDetailQuery,
  useUpdateBranchAssignmentMutation,
} from "store/services/branchAssignmentApi";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { BranchAssignmentForm } from "./BranchAssignmentComponents/BranchAssignmentForm";

const BranchAssignmentEditScreen = () => {
  const location = useLocation();
  const { id } = useParams();
  const { from } = location.state || {};
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Branch-Assignment",
      path: "/app/crm/branchAssignment/list",
    },
    from === "detail" && {
      title: "Branch Assignment Detail",
      path: `/app/crm/branchAssignment/${id}/detail`,
    },
    {
      title: "Edit Branch Assignment",
    },
  ].filter(Boolean);

  const {
    data: branchAssignmentDetail,
    isLoading: loadingBranchAssignmentDetail,
  } = useGetBranchAssignmentDetailQuery(id);
  const [
    updateBranchAssignment,
    { isLoading: updatingBranchAssignment, error },
  ] = useUpdateBranchAssignmentMutation();

  const handleBranchAssignmentUpdate = async (data) => {
    const {
      hasCustomAssignment,
      user,
      branches,
      region,
      district,
      municipality,
      assignmentType,
      status,
    } = data;

    if (!user) {
      toast.error("User must be provided.");
      return;
    }

    const regionIds =
      region?.map((item) => item.id).filter(Boolean) || [];
    const districtIds =
      district?.map((item) => item.id).filter(Boolean) || [];
    const municipalityIds =
      municipality?.map((item) => item.id).filter(Boolean) || [];
    const branchIds = branches?.map((branch) => branch.id).filter(Boolean) || [];

    const updateData = {
      _id: id,
      user: user.id,
      hasCustomAssignment: Boolean(hasCustomAssignment),
      branches: branchIds,
      region: regionIds,
      district: districtIds,
      municipality: municipalityIds,
      assignmentType,
      status: Boolean(status) ? "Active" : "Inactive",
    };

    try {
      await updateBranchAssignment(updateData).unwrap();

      navigate(`/app/crm/branchAssignment/${id}/detail`);
      toast.success("Branch Assignment successfully updated!");
    } catch (error) {
      toast.error(
        error?.data?.message ??
        error?.message ??
        "Branch Assignment update failed!",
      );
    }
  };

  return (
    <BreadcrumbLayout
      loading={loadingBranchAssignmentDetail || updatingBranchAssignment}
      breadcrumbs={breadcrumbs}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <BranchAssignmentForm
          branchAssignmentDetail={branchAssignmentDetail}
          isBusy={loadingBranchAssignmentDetail || updatingBranchAssignment}
          onSubmit={handleBranchAssignmentUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default BranchAssignmentEditScreen;
